import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import ProjectEditor from "@/pages/ProjectEditor";
import ProjectDetail from "@/pages/ProjectDetail";
import PublicProfile from "@/pages/PublicProfile";
import Discover from "@/pages/Discover";
import Settings from "@/pages/Settings";
import Advertise from "@/pages/Advertise";
import Admin from "@/pages/Admin";

function Layout() {
    return (
        <div className="min-h-screen flex flex-col bg-[#FCFCFC]">
            <Navbar />
            <main className="flex-1">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
}

function NotFound() {
    return (
        <div className="max-w-3xl mx-auto px-6 py-24 text-center">
            <div className="text-overline text-[#E63946] mb-2">404</div>
            <h1 className="font-display text-5xl font-black tracking-tighter uppercase mb-3">Page not found</h1>
            <p className="text-neutral-600 mb-8">The page you're looking for has gone walkabout.</p>
            <a href="/" className="btn-ghost inline-flex">Back home</a>
        </div>
    );
}

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route element={<Layout />}>
                            <Route path="/" element={<Landing />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/register" element={<Register />} />
                            <Route path="/discover" element={<Discover />} />
                            <Route path="/advertise" element={<Advertise />} />
                            <Route path="/b/:slug" element={<PublicProfile />} />
                            <Route path="/p/:id" element={<ProjectDetail />} />
                            <Route path="/projects/:id" element={<ProjectDetail />} />
                            <Route
                                path="/dashboard"
                                element={
                                    <ProtectedRoute>
                                        <Dashboard />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/projects/new"
                                element={
                                    <ProtectedRoute>
                                        <ProjectEditor />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/projects/:id/edit"
                                element={
                                    <ProtectedRoute>
                                        <ProjectEditor />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/settings"
                                element={
                                    <ProtectedRoute>
                                        <Settings />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/admin"
                                element={
                                    <ProtectedRoute>
                                        <Admin />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="*" element={<NotFound />} />
                        </Route>
                    </Routes>
                </BrowserRouter>
                <Toaster position="bottom-right" richColors closeButton />
            </AuthProvider>
        </div>
    );
}

export default App;
